export default __webpack_public_path__ + "static/media/communitycollege.721e2875.jpeg";